import { Select } from "antd";
import { TenantTipoHabitacao } from "core/resources/enums/tenant";
import SelectBaseAntd, { SelectBaseAntdProps } from "../SelectBaseAntd";

const { Option } = Select;

function SelectTipoHabitacao({ ...rest }: SelectBaseAntdProps) {
  return (
    <SelectBaseAntd size="large" placeholder="Tipo de Condomínio" {...rest}>
      <Option value={TenantTipoHabitacao.Comercial}>Comercial</Option>
      <Option value={TenantTipoHabitacao.Misto}>Misto</Option>
      <Option value={TenantTipoHabitacao.Residencial}>Residêncial</Option>
    </SelectBaseAntd>
  );
}

export default SelectTipoHabitacao;
